/**
 * 송금 모달 금액 (정산일보 지불운송비 = pay 기준)
 * - 일반: 산재보험 = 지불 × 49.9% × 1.76% ÷ 2 → 원 단위 반올림 후 10원 단위 반올림, 송금액 = 지불×1.1 − 산재
 * - 예외(사업자번호): 숫자만 보면 `99` 단독 이거나, 네 번째 숫자가 `8`이면 산재 미적용·송금액 = 지불×1.1
 */

const SANJE_FACTOR = (0.499 * 0.0176) / 2;

/** 산재보험을 계산하지 않고 송금만 지불×1.1 로 할지 */
export function shouldSkipSanjeInsurance(businessNumber: string | null | undefined): boolean {
  const s = String(businessNumber ?? '').replace(/[^\d]/g, '');
  if (s === '99') return true;
  if (s.length >= 4 && s.charAt(3) === '8') return true;
  return false;
}

/**
 * 산재보험 표시용: 원 단위 금액을 10원 단위로 **반올림** (일의 자리는 항상 0)
 */
export function roundSanjeToTenWon(won: number): number {
  const n = Math.round(Number(won));
  if (!Number.isFinite(n) || n <= 0) return 0;
  return Math.round(n / 10) * 10;
}

export function computeSanjeAndRemittance(
  pay: number,
  businessNumber?: string | null
): { sanje: number; remittance: number } {
  const p = Number(pay);
  if (!Number.isFinite(p) || p <= 0) {
    return { sanje: 0, remittance: 0 };
  }
  if (shouldSkipSanjeInsurance(businessNumber)) {
    return { sanje: 0, remittance: Math.round(p * 1.1) };
  }
  const sanjePart = p * SANJE_FACTOR;
  const sanjeInt = Math.round(sanjePart);
  const sanje = roundSanjeToTenWon(sanjeInt);
  const remittance = Math.round(p * 1.1 - sanje);
  return { sanje, remittance };
}
